import { render } from "./ArenaGameView.vue?vue&type=template&id=288e849e&scoped=true"
import script from "./ArenaGameView.vue?vue&type=script&lang=js"
export * from "./ArenaGameView.vue?vue&type=script&lang=js"

import "./ArenaGameView.vue?vue&type=style&index=0&id=288e849e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288e849e"]])

export default __exports__